// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2MbI7","title":"Images45_title__3W5hC","images":"Images45_images__1RDOr"};